import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";

const fmt = (iso) => new Date(iso).toLocaleString("de-DE");

export default function AuditLog() {
  const [entries, setEntries] = useState([]);
  useEffect(() => { (async () => { try { setEntries((await api.get("/audit")).data); } catch { /* ignore */ } })(); }, []);
  return (
    <div className="space-y-4">
      <div>
        <h1 className="text-2xl heading font-semibold">Audit-Log</h1>
        <p className="text-sm text-muted-foreground">Protokoll aller relevanten Aktionen.</p>
      </div>
      <Card className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-muted/60 text-xs uppercase tracking-wider text-muted-foreground">
            <tr>
              <th className="text-left px-4 py-2">Zeit</th>
              <th className="text-left px-4 py-2">Benutzer</th>
              <th className="text-left px-4 py-2">Aktion</th>
              <th className="text-left px-4 py-2">Objekt</th>
              <th className="text-left px-4 py-2">Details</th>
            </tr>
          </thead>
          <tbody>
            {entries.map((e) => (
              <tr key={e.id} className="border-t border-border row-hover">
                <td className="px-4 py-2 tabular-nums whitespace-nowrap">{fmt(e.created_at)}</td>
                <td className="px-4 py-2 font-mono">{e.actor_username || "—"}</td>
                <td className="px-4 py-2">{e.action}</td>
                <td className="px-4 py-2 capitalize">{e.entity_type}</td>
                <td className="px-4 py-2 font-mono text-xs text-muted-foreground">{e.details ? JSON.stringify(e.details) : ""}</td>
              </tr>
            ))}
            {entries.length === 0 && (
              <tr><td colSpan={5} className="px-4 py-6 text-center text-sm text-muted-foreground">Noch keine Einträge.</td></tr>
            )}
          </tbody>
        </table>
      </Card>
    </div>
  );
}
